<template>
 <div :style="{ backgroundColor: backgroundcolor }" id="wrapper">

   <div class="baselogin">
     <div id="logo_chat_nuevo">
          <img src="https://imagenes.leon.gob.mx/logo-leon-bco.svg" width="150px" >
      </div>
      <div id="logo_chat_psico">
          <img src="img/logoatencion.png" width="90px" >
      </div>

    <form class="form-signin" @submit.prevent="checkForm">
      <div class="input-group">
         <div class="input-group-prepend">
            <span class="input-group-text bg-white  border-right-0"><i class="fa fa-envelope" style="color:#2C4DB8;"></i></span>
          </div>
          <input type="email" class="form-control border-left-0" placeholder="Correo electrónico" v-model="name" required autofocus>
        </div>
         <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text bg-white border-right-0"><i class="fa fa-lock" style="color:#2C4DB8;"></i></span>
          </div>
              <input type="password" class="form-control border-left-0" placeholder="Clave" v-model="clave" required >
        </div>
      <button  class="btn"  
      style="background-color:#ff9c00;color: #fff; margin-top: 10px"
       id="btnEntrar">Ingresar</button>
      </form>
      <div  class="alert alert-danger" v-if="error" role="alert">{{error}}</div>
   </div>
  <div class="a" style="--n: 5;" v-if="check">
  <div class="dot" style="--i: 0;"></div>
  <div class="dot" style="--i: 1;"></div>
  <div class="dot" style="--i: 2;"></div>
  <div class="dot" style="--i: 3;"></div>
  <div class="dot" style="--i: 4;"></div>
  </div>
</div>


</template>

<script>
import firebase from 'firebase';


export default {
  name: 'Acceso',
  props: {
    msg: String
  },
  data() {
    return {
      backgroundcolor: "#fff",
      name: null,
      auth: null,
      clave: null,
      opsess: null,
      error:null,
      check:null
    }
  },
  methods: {
    isAuth: function () {
      var user = firebase.auth().currentUser;
      if (user) {
        return true;
      }
    },
    onOperatorClosesBrowser:function(){
      console.log("1")
    },
    checkForm() {
      let self = this;
      let clave = this.clave;
      let userEmail = this.name;
      this.error = false;
      this.check = true
      this.isBtnLogin = true;
      localStorage.removeItem("LEO_REI");
      firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
        .then(function () {
          firebase.auth().signInWithEmailAndPassword(userEmail, clave)
            .then(function (user) {
              /* validar si ya existe mi cuenta en online borrarlo */

              firebase.database().ref(`users/online/`).push({
                loggIn: true,
                email : userEmail,
              }).then((sessionId) => {
                self.check = false
                self.sessId = sessionId.key;
                localStorage.opSess = self.sessId;
                self.$router.push({
                  name: "Lobby",
                  params: {
                    name: user,
                    opsess: self.sessId
                  }
                })
              })
            })
            .catch(function (error) {
              var errorCode = error.code;
              console.log(error)
              self.error = "Error de autenticación"
              self.check = false
              
            });
        })
        .catch(function (error) {
          var errorCode = error.code;
          var errorMessage = error.message;
        });
    }
  },

  created() {
    /* si estando logeado, vuelven al acceso*/
    
    window.addEventListener('beforeunload',this.onOperatorClosesBrowser);
    this.isBtnLogin = false;
    var user = firebase.auth().currentUser;
    let sessionId = localStorage.opSess 
    let LEO_REI = localStorage.LEO_REI 
    var self = this;
    if(user!=null){
      if(sessionId){
        self.$router.push({
                name: "Lobby",
                params: {
                  name: user,
                  opsess: sessionId
                }
              })
      }
    }
    else{
      if(sessionId!=undefined && LEO_REI==1){
        localStorage.removeItem("opSess")
        localStorage.removeItem("LEO_REI")
      }
    }
  }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src="@/assets/css/signin.css"/>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #wrapper{
    background-image: url("/img/fondo.jpeg");
    background-size: cover;
  }

  .baselogin{
    background-image: url("/img/baselogin.png");
    width: 400px;
    height: 550px;
    position: relative;
    left: calc(50% - 200px);
    top: 50px;
    /* border: 1px solid red; */
    background-size: cover;
  }

  #logo_chat_nuevo{
    /*padding: 100px 0;*/
    padding: 125px 0 105px 0;
  }
  #logo_chat_nuevo img{
    width: 30%;
  }
  .input-group{
    margin-bottom: 10px;
  }
  .input-group-prepend{
    height: 34px;
  }
  .input-group-text{
    border: none;
  }

  .input-group-text i{
    color: #103463 !important;
  }
  .input-group input{
     height: 34px !important;
     background-color: #a1c3e1;
     color: #fff;
  }

  .input-group input::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #fff;
    opacity: 1; /* Firefox */
  }

  .input-group input:-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: #fff;
  }

  .input-group input::-ms-input-placeholder { /* Microsoft Edge */
    color: #fff;
  }

</style>